import { createStore } from 'vuex'
import jwtDecode from 'jwt-decode'

import {
  AUTH_BLACKLIST_TOKEN_API,
  AUTH_GET_TOKEN_API,
  AUTH_REFRESH_TOKEN_API,
  GET_MY_PROFILE_API_HOOK,
  fetch_api_json,
  fetch_auth_json,
} from '@/common/api_endpoints'

const taskSavingModule = {
  state: {
    localTaskData: localStorage.getItem('local_task_data')
      ? JSON.parse(localStorage.getItem('local_task_data'))
      : {},
  },
  mutations: {
    setLocalTaskData(state, { new_task_data }) {
      state.localTaskData = new_task_data
      console.log('JSON.stringify')
      localStorage.setItem('local_task_data', JSON.stringify(new_task_data))
    },
  },
  actions: {
    async getOneTaskData(context, task_id) {
      const raw = context.state.localTaskData[task_id]
      if (!raw) {
        return null
      }
      if (Array.isArray(raw)) {
        return { pieces: raw, synced_at: null }
      }
      if (raw.pieces) {
        return raw
      }
      return null
    },
    async saveOneTaskData(context, { task_id, one_task_data }) {
      const task_data = { ...context.state.localTaskData }
      const isEnvelope =
        one_task_data &&
        !Array.isArray(one_task_data) &&
        Array.isArray(one_task_data.pieces)
      const isEmptyObject =
        one_task_data &&
        !Array.isArray(one_task_data) &&
        !isEnvelope &&
        Object.keys(one_task_data).length === 0
      if (!one_task_data || isEmptyObject) {
        delete task_data[task_id]
      } else if (Array.isArray(one_task_data)) {
        const prev = task_data[task_id]
        const synced_at = prev && !Array.isArray(prev) ? prev.synced_at : null
        task_data[task_id] = { pieces: one_task_data, synced_at }
      } else {
        task_data[task_id] = one_task_data
      }
      context.commit('setLocalTaskData', { new_task_data: task_data })
    },
  },
}

let instructionAckRequest = null

const authenticationModule = {
  state: {
    accessToken: localStorage.getItem('access_token') || null,
    refreshToken: localStorage.getItem('refresh_token') || null,
    instructionAckLoaded: false,
    mustAcknowledgeInstruction: false,
  },
  mutations: {
    updateLocalStorage(state, { access, refresh }) {
      state.accessToken = access
      state.refreshToken = refresh
      localStorage.setItem('access_token', access)
      localStorage.setItem('refresh_token', refresh)
    },
    updateAccess(state, access) {
      state.accessToken = access
      localStorage.setItem('access_token', access)
    },
    setInstructionAck(state, { loaded, mustAcknowledge }) {
      state.instructionAckLoaded = loaded
      state.mustAcknowledgeInstruction = mustAcknowledge
    },
    destroyToken(state) {
      state.accessToken = null
      state.refreshToken = null
      state.instructionAckLoaded = false
      state.mustAcknowledgeInstruction = false
      instructionAckRequest = null
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
    },
  },
  actions: {
    async refreshToken(context) {
      if (context.state.refreshToken) {
        const res = await fetch_auth_json(AUTH_REFRESH_TOKEN_API, 'POST', {
          refresh: context.state.refreshToken,
        })
        const data = await res.json()
        if (data.access) {
          context.commit('updateAccess', data.access)
        }
        return data.access !== undefined
      } else {
        return false
      }
    },
    async loginUser(context, credentials) {
      const res = await fetch_auth_json(AUTH_GET_TOKEN_API, 'POST', {
        username: credentials.username,
        password: credentials.password,
        recaptcha: credentials.recaptcha,
      })
      let wrong_cred = res.status !== 200
      const data = await res.json()
      if (data.access && data.refresh) {
        context.commit('updateLocalStorage', {
          access: data.access,
          refresh: data.refresh,
        })
        context.commit('setInstructionAck', {
          loaded: false,
          mustAcknowledge: false,
        })
      }
      return wrong_cred
    },
    async logoutUser(context) {
      await fetch_auth_json(AUTH_BLACKLIST_TOKEN_API, 'POST', {
        refresh: context.state.refreshToken,
      })
      context.commit('destroyToken')
    },
    async getAuthHeader(context) {
      const jwtPayload = jwtDecode(context.state.accessToken)
      if (jwtPayload.exp < Date.now() / 1000) {
        await context.dispatch('refreshToken')
      }
      return `Bearer ${context.state.accessToken}`
    },
    async ensureInstructionAckStatus(context) {
      if (context.state.instructionAckLoaded) {
        return context.state.mustAcknowledgeInstruction
      }
      if (!instructionAckRequest) {
        instructionAckRequest = (async () => {
          const res = await fetch_api_json(GET_MY_PROFILE_API_HOOK, 'POST', {})
          if (!res || !res.ok) {
            return context.state.mustAcknowledgeInstruction
          }
          const data = await res.json()
          const mustAcknowledge = Boolean(data.must_acknowledge_instruction)
          context.commit('setInstructionAck', {
            loaded: true,
            mustAcknowledge,
          })
          return mustAcknowledge
        })().finally(() => {
          instructionAckRequest = null
        })
      }
      return instructionAckRequest
    },
    async acknowledgeInstruction(context) {
      const res = await fetch_api_json(GET_MY_PROFILE_API_HOOK, 'POST', {
        acknowledge_instruction: true,
      })
      if (!res || !res.ok) {
        throw new Error('Failed to acknowledge instruction')
      }
      context.commit('setInstructionAck', {
        loaded: true,
        mustAcknowledge: false,
      })
    },
  },
  getters: {
    loggedIn(state) {
      return state.accessToken != null
    },
  },
}

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
      window.dispatchEvent(new Event('resize'))
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
      window.dispatchEvent(new Event('resize'))
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
      window.dispatchEvent(new Event('resize'))
    },
  },
  actions: {},
  modules: { authenticationModule, taskSavingModule },
})
